import { BaseService } from 'core/services';
import ItemSubcategoryRouteService from './ItemSubcategoryRouteService';

class ItemSubcategoryService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ItemSubcategoryRouteService());
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }
}

export default ItemSubcategoryService;
